import { SvgName } from "../../types/svg";

type SvgProps = {
  name: SvgName;
  alt: string;
  className?: string;
  isColored?: boolean;
  width?: number;
};

export const Svg = ({
  name,
  alt,
  className,
  isColored = false,
  width,
}: SvgProps) => {
  return (
    <img
      src={
        isColored
          ? `/images/svg/svg_colors/${name}.svg`
          : `/images/svg/${name}.svg`
      }
      alt={alt}
      className={className}
      style={{
        width,
        height: width ? "auto" : undefined,
      }}
    />
  );
};
